/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressDtoFromJSON, AddressDtoToJSON, } from './AddressDto';
import { BountyLocationFromJSON, BountyLocationToJSON, } from './BountyLocation';
import { CrashLinkStatusFromJSON, CrashLinkStatusToJSON, } from './CrashLinkStatus';
import { IncidentReportTypeFromJSON, IncidentReportTypeToJSON, } from './IncidentReportType';
import { ModerationStatusFromJSON, ModerationStatusToJSON, } from './ModerationStatus';
import { ViewIncidentFileResponseFromJSON, ViewIncidentFileResponseToJSON, } from './ViewIncidentFileResponse';
/**
 * Check if a given object implements the ViewIncidentReportResponse interface.
 */
export function instanceOfViewIncidentReportResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function ViewIncidentReportResponseFromJSON(json) {
    return ViewIncidentReportResponseFromJSONTyped(json, false);
}
export function ViewIncidentReportResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'incidentReportType': !exists(json, 'incidentReportType') ? undefined : IncidentReportTypeFromJSON(json['incidentReportType']),
        'hasContentWarning': !exists(json, 'hasContentWarning') ? undefined : json['hasContentWarning'],
        'isFilmedInPublicLocation': !exists(json, 'isFilmedInPublicLocation') ? undefined : json['isFilmedInPublicLocation'],
        'userConsentProvided': !exists(json, 'userConsentProvided') ? undefined : json['userConsentProvided'],
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'location': !exists(json, 'location') ? undefined : BountyLocationFromJSON(json['location']),
        'address': !exists(json, 'address') ? undefined : AddressDtoFromJSON(json['address']),
        'incidentDateTime': !exists(json, 'incidentDateTime') ? undefined : (json['incidentDateTime'] === null ? null : new Date(json['incidentDateTime'])),
        'incidentTimezone': !exists(json, 'incidentTimezone') ? undefined : json['incidentTimezone'],
        'userSubmittedIncidentDescription': !exists(json, 'userSubmittedIncidentDescription') ? undefined : json['userSubmittedIncidentDescription'],
        'primaryUserIncidentFileId': !exists(json, 'primaryUserIncidentFileId') ? undefined : json['primaryUserIncidentFileId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'userProfileId': !exists(json, 'userProfileId') ? undefined : json['userProfileId'],
        'openDataCrashId': !exists(json, 'openDataCrashId') ? undefined : json['openDataCrashId'],
        'crashLinkStatus': !exists(json, 'crashLinkStatus') ? undefined : CrashLinkStatusFromJSON(json['crashLinkStatus']),
        'moderationStatus': !exists(json, 'moderationStatus') ? undefined : ModerationStatusFromJSON(json['moderationStatus']),
        'incidentDescription': !exists(json, 'incidentDescription') ? undefined : json['incidentDescription'],
        'userIncidentFileCollection': !exists(json, 'userIncidentFileCollection') ? undefined : (json['userIncidentFileCollection'] === null ? null : json['userIncidentFileCollection'].map(ViewIncidentFileResponseFromJSON)),
        'thumbnailUrl': !exists(json, 'thumbnailUrl') ? undefined : json['thumbnailUrl'],
        'previewUrl': !exists(json, 'previewUrl') ? undefined : json['previewUrl'],
    };
}
export function ViewIncidentReportResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'incidentReportType': IncidentReportTypeToJSON(value.incidentReportType),
        'hasContentWarning': value.hasContentWarning,
        'isFilmedInPublicLocation': value.isFilmedInPublicLocation,
        'userConsentProvided': value.userConsentProvided,
        'countryCode': value.countryCode,
        'location': BountyLocationToJSON(value.location),
        'address': AddressDtoToJSON(value.address),
        'incidentDateTime': value.incidentDateTime === undefined ? undefined : (value.incidentDateTime === null ? null : value.incidentDateTime.toISOString()),
        'incidentTimezone': value.incidentTimezone,
        'userSubmittedIncidentDescription': value.userSubmittedIncidentDescription,
        'primaryUserIncidentFileId': value.primaryUserIncidentFileId,
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'userProfileId': value.userProfileId,
        'openDataCrashId': value.openDataCrashId,
        'crashLinkStatus': CrashLinkStatusToJSON(value.crashLinkStatus),
        'moderationStatus': ModerationStatusToJSON(value.moderationStatus),
        'incidentDescription': value.incidentDescription,
        'userIncidentFileCollection': value.userIncidentFileCollection === undefined ? undefined : (value.userIncidentFileCollection === null ? null : value.userIncidentFileCollection.map(ViewIncidentFileResponseToJSON)),
        'thumbnailUrl': value.thumbnailUrl,
        'previewUrl': value.previewUrl,
    };
}
